"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClueyLogoBase = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const ClueyLogoBase = ({ src, className }) => {
    return (react_1.default.createElement("img", { src: src, alt: "Cluey Logo", className: (0, classnames_1.default)('h-[30px] w-[80px] lg:h-[40px] lg:w-[106px]', className) }));
};
exports.ClueyLogoBase = ClueyLogoBase;
